import React, { useState } from 'react';
import {
    List, Datagrid, SimpleForm, TextInput, ImageField, SelectInput, EditButton,
    Edit, SaveButton, Toolbar as RaToolbar, FunctionField, SimpleList, DateField, useRedirect
} from 'react-admin';
import { withStyles, makeStyles, useMediaQuery, Avatar, IconButton, CircularProgress, TextField as MuiTextField, DialogActions, Button, Dialog, DialogContent } from '@material-ui/core';
import { vehicleSvgs, hideMobileNumber, hideVehicleNumber } from "./sharedData";
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox'
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import CustomFilter from './components/CustomFilter';
import moment from 'moment'
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import notify from './components/CustomUseNotify';
import CloseIcon from '@material-ui/icons/Close';

import Transmission from './images/Transmission.svg'
import Fuel from './images/Fuel.svg'
import G1 from './images/Group 5141.svg'
import G2 from './images/Group 5142.svg'
import Path from './images/Path679.png'

import BikeBlack from './images/BikeBlack.png'
import BikeBlue from './images/BikeBlue.png'
import BikeGray from './images/BikeGray.png'
import BikeRed from './images/BikeRed.png'
import BikeWhite from './images/BikeWhite.png'
import CarBlack from './images/CarBlack.png'
import CarBlue from './images/CarBlue.png'
import CarGray from './images/CarGray.png'
import CarRed from './images/CarRed.png'
import CarWhite from './images/CarWhite.png'
import { fastagIssuers } from "./sharedData";
import ParkSmartTag from './images/parksmartTag.png';
import SearchIcon from '@material-ui/icons/Search';
import config from "./config.json";
import ReplayIcon from '@material-ui/icons/Replay';
import { saveTokens } from './utils/saveTokens';
// import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        width: 400
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    image: {
        maxHeight: '224px',
        borderRadius: 10,
        cursor: "pointer"
    },
});

const renderVehicleType = row => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 48 }} alt={row.vehicle_type_label} />
            {/* row.vehicle_type_label */}
        </div>
        :
        null
);

const renderBrand = row => row.brand === "null" ? "-" : row.brand
const renderModel = row => row.model === "null" ? "-" : row.model

const RenderVerify = (props) => {
    const { record } = props
    return (
        <>
            {
                record && record.verified === 1 ? <div style={{ fontSize: "0.875rem", color: "#18cc69", fontWeight: "bold" }}>Verified</div> : <EditButton style={{ letterSpacing: 1, padding: "6px 20px 6px 15px", textTransform: "none", borderRadius: 100 }} disableElevation record={record} label='Verify' icon={null} variant="contained" />
            }
        </>
    )
}

const RenderView = (props) => {
    const { record } = props
    return (
        <>
            {
                record.verified === 1 ? <ViewDocuments record={record} /> : null
            }
        </>
    )
}

const ViewDocuments = ({ record }) => {
    const classes = useStyles()
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const idBackProof = row => row.id_proof_back_url !== null ?
        <div style={{ flex: 1, zIndex: 2, textAlign: "center", border: "1px solid #18cc69", borderRadius: 10 }}>
            <ImageField classes={classes} source="id_proof_back_url" title="ID Proof Back" alt="ID Proof Back" />
        </div>
        :
        <p style={{ fontSize: "12px" }}>Image Not found</p>

    const idFrontProof = row => row.id_proof_url !== null ?
        <div style={{ flex: 1, zIndex: 2, textAlign: "center", border: "1px solid #18cc69", borderRadius: 10 }}>
            <ImageField classes={classes} source="id_proof_url" title="ID Proof Front" alt="ID Proof Front" />
        </div>
        :
        <p style={{ fontSize: "12px" }}>Image Not found</p>

    const rcImage = row => row.rc_image_url !== null ?
        <div style={{ flex: 1, zIndex: 2, textAlign: "center", border: "1px solid #18cc69", borderRadius: 10 }}>
            <ImageField classes={classes} source="rc_image_url" title="RC Image" alt="RC Image" />
        </div>
        :
        <p style={{ fontSize: "12px" }}>Image Not found</p>



    return (
        <div>
            <IconButton onClick={handleClickOpen}>
                <VisibilityIcon />
            </IconButton>
            <Dialog fullWidth open={open} onClose={handleClose} classes={{ paper: classes.dialogPaperBig }}>
                <SimpleReactLightbox>
                    <SRLWrapper>
                        <DialogContent>
                            <SimpleForm toolbar={false}>
                                <div style={{ paddingTop: "10px" }}>

                                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", }}>
                                        <div>
                                            <div className="formLabel-regular" style={{ color: "#777", fontSize: "12px" }}>RC Image</div>
                                            <FunctionField source="rc_image_url" label="RC Image" render={rcImage} />
                                        </div>
                                        <div style={{ marginLeft: "40px" }}>
                                            <div className="formLabel-regular" style={{ color: "#777", fontSize: "12px" }}>ID Proof Front</div>
                                            <FunctionField source="id_proof_url" label="ID Proof Front" render={idFrontProof} />
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "20px" }}>
                                        <div className="formLabel-regular" style={{ color: "#777", fontSize: "12px" }}>ID Proof Back</div>
                                        <FunctionField source="id_proof_back_url" label="ID Proof Back" render={idBackProof} />
                                    </div>

                                    <div style={{ display: "flex", flexDirection: "column", marginTop: "30px" }}>

                                        <div style={{ display: "flex", columnGap: 20 }}>
                                            {
                                                record.brand && <MuiTextField
                                                    label="Brand"
                                                    defaultValue={record.brand}
                                                    disabled={true}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            }
                                            {
                                                record.model && <MuiTextField
                                                    defaultValue={record.model}
                                                    label="Model"
                                                    disabled={true}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            }
                                        </div>
                                        <div style={{ display: "flex", columnGap: 20, marginTop: 20 }}>
                                            {
                                                record.color && <MuiTextField
                                                    label="Color"
                                                    defaultValue={record.color}
                                                    disabled={true}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            }
                                            {
                                                record.chassis_number && <MuiTextField
                                                    defaultValue={record.chassis_number}
                                                    label="Chassis Number"
                                                    disabled={true}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            }
                                        </div>
                                        <div style={{ display: "flex", columnGap: 20, marginTop: 20 }}>
                                            {
                                                record.fuel_type && <MuiTextField
                                                    defaultValue={record.fuel_type}
                                                    label="Fuel Type"
                                                    disabled={true}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            }
                                            {
                                                record.fuel_transmission && <MuiTextField
                                                    defaultValue={record.fuel_transmission}
                                                    label="Transmission"
                                                    disabled={true}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </SimpleForm>
                        </DialogContent>
                    </SRLWrapper>
                </SimpleReactLightbox>
                <DialogActions style={{ padding: "22px 35px" }}>
                    <Button onClick={handleClose} variant='contained' disableElevation style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }}>Close</Button>
                </DialogActions>
            </Dialog >
        </div>
    );
}

const validateEdit = values => {
    const errors = {};
    if (typeof values.mobile === "string" && values.mobile.length > 0 && values.mobile.search(/^\d{10}$/g) === -1) {
        errors.mobile = 'Invalid Mobile Number';
    }
    return errors;
};

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

const CustomToolbar = withStyles(toolbarStyles)(props => (
    <RaToolbar {...props}>
        <SaveButton icon={<DoneOutlineIcon />} label="Verify" />
    </RaToolbar>
));

const CustomLayout = (props) => {

    const classes = useStyles();
    
    const idBackProof = row => row.id_proof_back_url !== null ?
        <div style={{ flex: 1, zIndex: 2, textAlign: "center", border: "1px solid #18cc69", borderRadius: 10 }}>
            <ImageField classes={classes} source="id_proof_back_url" title="ID Proof Back" alt="ID Proof Back" />
        </div>
        :
        <p style={{ fontSize: "12px" }}>Image Not found</p>

    const idFrontProof = row => row.id_proof_url !== null ?
        <div style={{ flex: 1, zIndex: 2, textAlign: "center", border: "1px solid #18cc69", borderRadius: 10 }}>
            <ImageField classes={classes} source="id_proof_url" title="ID Proof Front" alt="ID Proof Front" />
        </div>
        :
        <p style={{ fontSize: "12px" }}>Image Not found</p>

    const rcImage = row => row.rc_image_url !== null ?
        <div style={{ flex: 1, zIndex: 2, textAlign: "center", border: "1px solid #18cc69", borderRadius: 10 }}>
            <ImageField classes={classes} source="rc_image_url" title="RC Image" alt="RC Image" />
        </div>
        :
        <p style={{ fontSize: "12px" }}>Image Not found</p>



    return (
        <SimpleReactLightbox>
            <SRLWrapper>
                <div style={{ paddingTop: "10px" }}>

                <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", }}>
                                        <div>
                                            <div className="formLabel-regular" style={{ color: "#777", fontSize: "12px" }}>RC Image</div>
                                            <FunctionField source="rc_image_url" label="RC Image" render={rcImage} />
                                        </div>
                                        <div style={{ marginLeft: "40px" }}>
                                            <div className="formLabel-regular" style={{ color: "#777", fontSize: "12px" }}>ID Proof Front</div>
                                            <FunctionField source="id_proof_url" label="ID Proof Front" render={idFrontProof} />
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "20px" }}>
                                        <div className="formLabel-regular" style={{ color: "#777", fontSize: "12px" }}>ID Proof Back</div>
                                        <FunctionField source="id_proof_back_url" label="ID Proof Back" render={idBackProof} />
                                    </div>

                    <div style={{ display: "flex", flexDirection: "column", marginTop: "30px" }}>

                        <div style={{ display: "flex", columnGap: 20 }}>
                            <TextInput label="Brand" source="brand" variant="outlined" inputProps={{ maxLength: 50 }} />
                            <TextInput label="Model" source="model" variant="outlined" inputProps={{ maxLength: 10 }} />
                        </div>
                        <div style={{ display: "flex", columnGap: 20 }}>
                            <TextInput label="Color" source="vehicle_color" variant="outlined" inputProps={{ maxLength: 50 }} />
                            <TextInput label="Chassis No." source="chassis_number" variant="outlined" inputProps={{ maxLength: 10 }} />
                        </div>
                        <div style={{ display: "flex", columnGap: 20 }}>
                            <SelectInput source="fuel_type" variant="outlined" choices={[
                                { id: 'petrol', name: 'Petrol' },
                                { id: 'diesel', name: 'Diesel' },
                                { id: 'cng', name: 'CNG' },
                            ]} />
                            <SelectInput source="fuel_transmission" variant="outlined" choices={[
                                { id: 'manual', name: 'Manual' },
                                { id: 'auto', name: 'Auto' },
                            ]} />
                        </div>
                    </div>
                </div>
            </SRLWrapper>
        </SimpleReactLightbox>
    );
}


export const VerifyVehiclesListEdit = (props) => {
    const classes = useStyles();
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Updated", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }
    return (
        <Edit {...props} onFailure={onFailure} onSuccess={onSuccess} undoable={false} classes={{ noActions: classes.editNoActions }}>
            <SimpleForm redirect="list" component={CustomLayout} toolbar={<CustomToolbar />} style={{ padding: "0 12px" }} validate={validateEdit} >
            </SimpleForm>
        </Edit>
    );
}

const CATEGORY = "VEHICLES SECTION"

export const VerifyVehiclesList = (props) => {
    const eventTracker = UseAnalyticsEvent()
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [showFilter] = useState(sessionStorage.getItem("role") === "admin");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number", "Brand", "Model"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)

    const [recordData, setRecordData] = useState(null)
    const [displayModal, setDisplayModal] = useState(null);
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};
    let filterTypesInitState = [
        {
            filterType: "Vehicle",
            dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Vehicle User",
            dataList: [{ name: "Jammu Users", id: 1 }, { name: "Other Users", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: showFilter
        }
    ]

    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    let filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" } }

    React.useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Vehicle") {
                    values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
                if (filterListValue[val].filterType === "Vehicle User") {
                    values = { ...values, vehicleUser: filterListValue[val].value === "Jammu Users" ? true : filterListValue[val].value === "Other Users" ? false : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        eventTracker(CATEGORY, " VEHICLES LIST")
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div>
                <div className='customStyleForDataSearchDiv'>
                    <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                    <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
                    <GetVehicleFastags />
                </div>
                <List {...props}
                    style={{marginTop: 20}}
                    empty={false}
                    title="Verify Vehicles"
                    bulkActionButtons={false}
                    sort={{ field: 'created_on', order: 'DESC' }}
                    exporter={false}
                    filter={filter}
                    actions={false}
                    pagination={<CustomPagination />}
                >

                    {isSmallDevice ?
                        <SimpleList
                            leftIcon={row => <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10, overflow:"visible" }} />}
                            primaryText={record => hideVehicleNumber(record.vehicle_number.toUpperCase())}
                            secondaryText={record => (<div>
                                {record.mobile && <div><span style={{ color: "#5a5a5a" }}>Mob No: </span>{hideMobileNumber(record.mobile)}</div>}
                                {record.brand && <div><span style={{ color: "#5a5a5a" }}>Brand: </span>{record.brand}</div>}
                                {record.model && <div><span style={{ color: "#5a5a5a" }}>Model: </span>{record.model}</div>}
                                {record.created_on && <div><span style={{ color: "#5a5a5a" }}>Request At: </span>{renderTime(record["created_on"])}</div>}
                            </div>)}
                            onContextMenu={event => event.preventDefault()}
                            rightIcon={record => !viewOnly && record.verified === 1 ? <div style={{ fontSize: "0.875rem", color: "#18cc69", fontWeight: "bold" }}>Verified <ViewDocuments record={record} /></div> : <EditButton style={{ letterSpacing: 1, padding: "6px 20px 6px 15px", textTransform: "none", borderRadius: 100 }} disableElevation record={record} label='Verify' variant="contained" />}
                            linkType={false}
                            rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                        />
                        :
                        <Datagrid component={ScrollableTable}>
                            <FunctionField
                                source="vehicle_type"
                                label="Type"
                                render={(record) => record && renderVehicleType(record)}
                                sortable
                            />
                            <FunctionField
                                source="vehicle_number" label="Vehicle Number"
                                render={(record) => record && record.vehicle_number && <p style={{ color: "#334d6e", fontWeight: "bold", cursor: showFilter ? 'pointer' : 'default' }} onClick={() => {
                                    if (showFilter) {
                                        setDisplayModal(true)
                                        setRecordData(record)
                                    }
                                }}>{hideVehicleNumber(record.vehicle_number)}</p>}
                            />
                            <FunctionField source="mobile" label="Mobile" render={record => record && record["mobile"] && record["mobile"] !== null ? hideMobileNumber(record.mobile): "-"} />
                            <FunctionField
                                source="brand"
                                label="Brand"
                                render={(record) => record && renderBrand(record)}
                            /><FunctionField
                                source="model"
                                label="Model"
                                render={(record) => record && renderModel(record)}
                            />
                            <FunctionField source="created_on" label="Request At" render={record => record && renderTime(record["created_on"])} />
                            <DateField source="verified_on" label="Verified on" showTime={true} locales="fr-FR" />
                            {!viewOnly && <RenderVerify label="Verify" source="verified" />}
                            {!viewOnly && <RenderView label="View" source="verified" />}
                        </Datagrid>
                    }
                </List>
            </div>
            {displayModal && recordData && <CustomModal displayModal={displayModal} setDisplayModal={setDisplayModal} vehicleData={recordData} allowVerification={true} />}
        </>
    )
};


const renderVehicleColor = (type, color) => {
    if (type === "4") {
        if (color === "Red") {
            return CarRed
        } else if (color === "Black") {
            return CarBlack
        } else if (color === "White") {
            return CarWhite
        } else if (color === "Gray") {
            return CarGray
        } else {
            return CarBlue
        }
    }
    if (type === "2") {
        if (color === "Red") {
            return BikeRed
        } else if (color === "Black") {
            return BikeBlack
        } else if (color === "White") {
            return BikeWhite
        } else if (color === "Gray") {
            return BikeGray
        } else {
            return BikeBlue
        }
    }
}

const CustomModal = ({ displayModal, setDisplayModal, vehicleData }) => {

    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [userFastags, setUserFastags] = useState(JSON.parse(vehicleData.fastags).filter((tag) => tag.rfid != null && tag.rfid !== 'null'))
    const [loading, setLoading] = useState(false)

    const fetchFastags = () => {

        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/getVehicleFastags?vehicle_id=${vehicleData.id}&vehicle_number=${vehicleData.vehicle_number}&chassis_number=${vehicleData.chassis_number}&saveTag=${true}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false)
                if (json.success) {
                    setUserFastags(json.data)
                }
                else notify(json.message, "warning");

            })
            .catch((error) => {
                console.log(error)
                notify("Something went wrong", "warning");
                setLoading(false)
            });
    }

    return (
        <div>
            <div className={`CustomModal ${displayModal ? "Show" : ""}`}>
                <div className='siteAuditsScroll' style={{ overflow: "auto", overflowX: "hidden", height: "calc(100vh - 50px)", margin: "0px 0px 0px 0px", padding: "10px 20px 20px 20px", color: "#272727" }}>
                    <div style={{ display: "flex", justifyContent: 'space-between', alignItems: "center", marginBottom: 15, columnGap: 10 }}>
                        <div>
                            <p style={{ fontWeight: "bold", lineHeight: "3px" }}><span>{vehicleData.vehicle_number.replace(/\d*$/, "")}</span>  <span style={{ color: "#18cc69" }}>{vehicleData.vehicle_number.match(/\d*$/)}</span></p>
                            <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>{vehicleData.brand ? vehicleData.brand : "Unknown"} {vehicleData.model ? vehicleData.model : "Unknown"}</p>
                        </div>
                        <IconButton
                            onClick={() => setDisplayModal(!displayModal)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", columnGap: 1, overflow: "hidden", position: "relative" }}>
                        <img style={{ position: "absolute", right: isSmallDevice ? "-22px" : "0px", cursor: "pointer", top: "0px" }} src={Path} alt='path' />
                        <div style={{ width: "50%" }}>
                            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 10, marginBottom: 5 }}>
                                <img src={Transmission} alt="Transmission" />
                                <div>
                                    <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>Transmission</p>
                                    <p style={{ fontSize: 14, fontWeight: "500", lineHeight: "3px" }}>{vehicleData.fuel_transmission ? vehicleData.fuel_transmission : "Unknown"}</p>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 10, marginBottom: 5 }}>
                                <img src={Fuel} alt="fuel" />
                                <div marginLeft={.7}>
                                    <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>Fuel</p>
                                    <p style={{ fontSize: 14, fontWeight: "500", lineHeight: "3px" }}>{vehicleData.fuel_type ? vehicleData.fuel_type : "Unknown"}</p>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 10, marginBottom: 5 }}>
                                <img src={vehicleData.verified === 1 ? G1 : G2} style={{ width: 26, height: 26, marginLeft: -1 }} alt="verify" />
                                <div style={{ marginLeft: -1 }}>
                                    <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>Verification</p>
                                    <p style={{ fontSize: 14, fontWeight: "500", lineHeight: "3px" }}>{vehicleData.verified === 1 ? "Verified" : "Not Verified"}</p>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 10, marginBottom: 5 }}>
                                <img src={Transmission} alt="Transmission" />
                                <div>
                                    <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>Chassis Number</p>
                                    <p style={{ fontSize: 14, fontWeight: "500", lineHeight: "3px" }}>{vehicleData.chassis_number ? vehicleData.chassis_number : "Unknown"}</p>
                                </div>
                            </div>
                        </div>
                        <div style={{ width: "50%", display: "flex", alignItems: "end", justifyContent: "end" }}>
                            <img style={{ width: "80%", minWidth: "230px", marginRight: "-70px" }} src={renderVehicleColor(vehicleData.vehicle_type, vehicleData.vehicle_color)} alt="Vehicle" />
                        </div>
                    </div>
                    {vehicleData.vehicle_type === '4' && <div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <p style={{ fontSize: 14, lineHeight: "3px", fontWeight: "bold" }}>Vehicle FASTags</p>

                            {!loading ? <IconButton onClick={() => fetchFastags()}>
                                <ReplayIcon style={{ fontSize: "20px" }} />
                            </IconButton>
                                :
                                <CircularProgress size="1rem" style={{ color: "#272727", marginRight: 15 }} thickness={6}></CircularProgress>}
                        </div>
                        {
                            userFastags.length !== 0 &&
                            <div style={{ marginTop: 20 }}>
                                {
                                    userFastags.map((tag) => {
                                        return (
                                            <div style={{ padding: 10, backgroundColor: "#5E8DD310", borderRadius: 5, marginBottom: 10 }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    <div>
                                                        <p style={{ fontSize: 14, color: '#272727', lineHeight: "3px", fontWeight: '600' }}>{tag.fastag_provider}</p>
                                                        <p style={{ fontSize: 12, lineHeight: "3px", color: '#9899A1' }}>BANK NAME</p>
                                                    </div>
                                                    {renderTagImagee(tag["rfid"])}
                                                </div>
                                                <div>
                                                    <p style={{ fontSize: 14, lineHeight: "3px", color: '#272727', fontWeight: '600' }}>{tag.rfid}</p>
                                                    <p style={{ fontSize: 12, lineHeight: "3px", color: '#9899A1' }}>TAG ID</p>
                                                </div>

                                                <div style={{ textAlign: "right" }}>
                                                    <p style={{ fontSize: 12, color: '#9899A1', lineHeight: "3px" }}>STATUS</p>
                                                    <p style={{ fontSize: 14, color: '#272727', lineHeight: "3px", fontWeight: '600' }}>{tag.status}</p>
                                                </div>

                                            </div>
                                        )
                                    })
                                }
                            </div>

                        }
                    </div>}

                </div>
            </div>
            <div
                className={`CustomOverlay ${displayModal ? "Show" : ""}`}
                onClick={() => setDisplayModal(!displayModal)}
            />
        </div >
    )
}

const renderTagImagee = record => {

    const issuerId = getFastagIssuerId(record);
    const issuer = fastagIssuers[issuerId] ? fastagIssuers[issuerId] : null;

    if (typeof issuer === "string")
        return <img src={`/images/${issuer.replace(/\s/g, "")}.png`} alt={issuer} style={{ width: 100, borderRadius: 10, border: "1px solid #aaa" }} />
    else if (typeof record.tag_id === "string" && record.tag_id !== "")
        return <img src={ParkSmartTag} alt="ParkSmart" style={{ width: 100, borderRadius: 10, display: "block", margin: "auto" }} />
    else
        return <div style={{ textAlign: "center" }}>-</div>
};

const getFastagIssuerId = (tagId) => {
    if (RegExp("^918907048").test(tagId)) {
        return "607417";
    } else {
        let tagIdBin = "";
        for (let i = 0; i < tagId.length; i++) {
            tagIdBin += (parseInt(tagId[i], 16).toString(2)).padStart(4, "0");
        }
        const issuerId = parseInt(tagIdBin.substr(43, 20), 2).toString();
        return issuerId;
    }
};

const GetVehicleFastags = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [searchText, setSearchText] = React.useState('')
    const [vehicleFastags, setVehicleFastags] = React.useState(null)

    const handleClose = () => {
        setOpen(false)
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const fetchFastags = () => {

        if (searchText === '' || searchText == null) {
            notify("Invalid Input", "warning")
            return
        }
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/getVehicleFastags?vehicle_number=${searchText}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false)
                if (json.success) {
                    setVehicleFastags(json.data)
                }
                else notify(json.message, "warning");

            })
            .catch((error) => {
                console.log(error)
                notify("Something went wrong", "warning");
                setLoading(false)
            });
    }

    return (
        <div>
            <Button
                className='customCreateBtnStyle'
                onClick={handleClickOpen}
            >
                <SearchIcon style={{ fontSize: "20px" }} />
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                classes={{ paper: classes.dialogPaper }}
                BackdropProps={{
                    classes: {
                        root: classes.backDrop
                    }
                }}
            >
                <DialogContent style={{ overflow: 'hidden' }}>
                    <p style={{ fontSize: 14, lineHeight: "3px", fontWeight: "bold" }}>Vehicle FASTags</p>
                    <MuiTextField style={{ width: "100%" }} variant='outlined' label="Vehicle Number" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                    {
                        vehicleFastags && vehicleFastags.length !== 0 &&
                        <div style={{ maxHeight: 200, overflow: 'auto', marginTop: 10 }}>
                            {
                                vehicleFastags.map((tag) => {
                                    return (
                                        <div style={{ padding: 10, backgroundColor: "#5E8DD310", borderRadius: 5, marginBottom: 10, marginRight: 10 }}>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <div>
                                                    <p style={{ fontSize: 14, color: '#272727', lineHeight: "3px", fontWeight: '600' }}>{tag.fastag_provider}</p>
                                                    <p style={{ fontSize: 12, lineHeight: "3px", color: '#9899A1' }}>BANK NAME</p>
                                                </div>
                                                {renderTagImagee(tag["rfid"])}
                                            </div>
                                            <div>
                                                <p style={{ fontSize: 14, lineHeight: "3px", color: '#272727', fontWeight: '600' }}>{tag.rfid}</p>
                                                <p style={{ fontSize: 12, lineHeight: "3px", color: '#9899A1' }}>TAG ID</p>
                                            </div>

                                            <div style={{ textAlign: "right" }}>
                                                <p style={{ fontSize: 12, color: '#9899A1', lineHeight: "3px" }}>STATUS</p>
                                                <p style={{ fontSize: 14, color: '#272727', lineHeight: "3px", fontWeight: '600' }}>{tag.status}</p>
                                            </div>

                                        </div>
                                    )
                                })
                            }
                        </div>

                    }

                </DialogContent>
                <DialogActions style={{ marginTop: 20 }}>
                    <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        Close
                    </Button>
                    <Button onClick={fetchFastags} color="contained" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
                        Search   {loading && <CircularProgress size="1rem" style={{ color: "#ffff", marginLeft: "20px" }} thickness={6}></CircularProgress>}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}